
import {Options, Vue} from "vue-class-component";
import {formatAmoutswitchCurrency} from "@/utils/configuration/formatters-config";
import { globalConfig, serviceName, amountHT, amountTTC, paymentDatesOption } from "@/utils";
import { businessDataUtils, paymentDatesOptions } from "@/types"
import store from "@/store";
@Options({
  props: ["data"],
})
export default class SummaryFinancingPartyInsurance extends Vue {
  formatAmoutswitchCurrency = formatAmoutswitchCurrency;
  serviceName = serviceName;
  amountHT = amountHT;
  amountTTC = amountTTC;
  paymentDatesOption = paymentDatesOption;
  businessDataUtils = businessDataUtils;
  paymentDatesOptions = paymentDatesOptions;
  data?: any;
  expanded = true;
  get calculatestatus() {
    return config.VUE_APP_CALCULATE
  }
  get offer() {
    return store.state.summaryPanelModule?.offer
  }

  get isExternalOffer() {
    return config.VUE_APP_CALCULATE === 'false'
      && this.offer?.businessData?.API === businessDataUtils.offerApiSource;
  }

  get beneficiaries() {
    let raw: any[] = [];
    if (this.isExternalOffer) {
      raw = this.data.associatedInsuranceBeneficiaries ?? [];
    } else {
      raw = this.data.beneficiaries ?? this.data.details ?? [];
    }
    if (!Array.isArray(raw)) {
      return [];
    }

    const paymentDatesOption =
      this.data.paymentDatesOption
      ?? this.data.proposalAccessoryPaymentDatesOption?.resourceUid;

    return raw.map((row: any) => {
      const amountWoTax = typeof row.amountWoTax === "object" && row.amountWoTax !== null
        ? row.amountWoTax.amount
        : row.amountWoTax ?? row.amount?.amount;
      const amountWTax = typeof row.amountWTax === "object" && row.amountWTax !== null
        ? row.amountWTax.amount
        : row.amountWTax ?? amountWoTax;

      return {
        ...row,
        partyName: row.partyName
          ?? [row.partyFirstName, row.partyFamilyName].filter(Boolean).join(" ").trim(),
        paymentDatesOption: row.paymentDatesOption ?? paymentDatesOption,
        amountWoTax,
        amountWTax,
      };
    });
  }

  rowKeyFn(row: any) {
    return row.partyUid ?? row.partyName ?? row.resourceUid ?? JSON.stringify(row);
  }

  get columns() {
    return globalConfig.table_config.partyInsuranceCol;
  }

}
